/**
 * The payment links whose own credit the bank has confirmed, by link id.
 *
 * A link names the credit that paid it; the credit counts only once it is
 * confirmed, not merely claimed against (Josh, 2026-09-14). Once a link is in
 * here, money a person said was in the bank for it has been handed over to
 * the credit (ADR 0312). One rule, read by the balance, the Payments tab and
 * the untick, so the three never disagree about whether a link has landed.
 */
export function linksWhoseCreditLanded(
  links: readonly { id: string; mercuryDepositId?: string | null }[],
  confirmedDepositIds: ReadonlySet<string>,
): Set<string> {
  return new Set(
    links
      .filter(
        (link) =>
          Boolean(link.mercuryDepositId) &&
          confirmedDepositIds.has(link.mercuryDepositId as string),
      )
      .map((link) => link.id),
  );
}
